import axios from 'axios';
import { getMicroServiceUrl } from '../helpers';

export const getUser = () => {
  return {
    type: 'GET_USER',
    payload: axios.get(`${getMicroServiceUrl('sponsor-portal')}user/profile`),
  };
};
